module.exports = __WEBPACK_EXTERNAL_MODULE_openfl_system_System__;